import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Card, Modal } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { deleteSchoolAccount, editUserSchool } from '../../actions/usersActions'
import Swal from 'sweetalert2'
import { getPaymentMethods, getSchool } from '../../actions/schoolsActions'
import { useNavigate } from 'react-router-dom'
import AddPaymentMethod from '../../components/payment/AddPaymentMethod'

export default function Config() {
    const { t } = useTranslation()
	const {client, logout} = useAuth()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {school, schooluser, resultPaymentMethod} = useSelector(state=>state.schools)
    const {resultuser} = useSelector(state=>state.users)

    const [formState, setFormState] = useState({})
    const [isError, setIsError] = useState("");
    const [password, setPassword] = useState("");
    const [comfirmPassword, setComfirmPassword] = useState("")
    const [hasNewPassword, setHasNewPassword] = useState(false)

    const [imageAux, setImage] = useState(null)
    
    const [showPassword, setShowPassword] = useState(false)
    const [showRepeatPassword, setShowRepeatPassword] = useState(false)

    const [showPaymentMethodModal, setShowPaymentMethodModal] = useState(false)

    useEffect(() => {
        if(client){
            dispatch(getSchool(client?.id))
            dispatch(getPaymentMethods(client?.id))
        }
    },[dispatch, client])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange  = (e) => {
        setFormState({
            ...formState,
            [e.target.name]: e.target.checked
        })
    }

    const handleAvailability = async(e) => {
        setFormState({
            ...formState,
            'notifications': e.target.checked
        })
    }

    const checkValidation = (e, position) => {
        const inputPassword = e.target.value;

        if(position === 'first'){
            setPassword(inputPassword)

            if (inputPassword !== comfirmPassword) {
                dontMatchPasswords()
            }else {
                matchPasswords()
            }
        }else{
            setComfirmPassword(inputPassword)

            if (inputPassword !== password) {
                dontMatchPasswords()
            }else {
                matchPasswords()
            }
        }
    }

    const matchPasswords = (e) => {
        setIsError("");
        setFormState({
            ...formState,
            'password': password
        })
        setHasNewPassword(false)
    }

    const dontMatchPasswords = (e) => {
        setIsError("Las contraseñas no coinciden");
        setFormState({
            ...formState,
            'password': ''
        })
        setHasNewPassword(true)
    }

    useEffect(() => {
        if(school){
            setFormState({
                email: schooluser.email,
                password: '',
                notifications: schooluser.notifications,
                image: schooluser.image
            })

			setImage(school.image)
        }
    // eslint-disable-next-line
    }, [school, schooluser])

    const handleAdd = async(e) => {
        e.preventDefault()
        dispatch(editUserSchool(imageAux, formState, client?.id))

    }

    const handleDeleteAccount = async() => {
        Swal.fire({
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('global.yes'),
            cancelButtonText: t('global.cancel'),
            title: t('global.deleteAccountQuestion'),
            text: t('config.school.deleteAccountDescription'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteSchoolAccount(client?.id))
            }
        })
    }

    useEffect(() => {
        if(resultuser){
            switch (resultuser) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.schooledit')
                    })
                    sessionStorage.setItem('firsttime', 'false')
                    navigate('/school/dashboard')
                    break;
                case 'email':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.emailduplicate')
                    })
                    break;
                case 'code':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('users.codeduplicate')
                    })
                    break;

                case 'deleteAccountSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('global.deleteAccountSuccess')
                    })
                    dispatch({
                        type: 'USER_RESET_RESULT'
                    })
                    logout()
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    useEffect(() => {
        if (resultPaymentMethod) {
            switch (resultPaymentMethod) {
                case 'success':
                    setShowPaymentMethodModal(false)
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('school.addPaymentMethod')
                    })
                    break;
                case 'successDelete':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('school.deletePaymentMethod')
                    })
                    break;
                default:
                    break;
            }
            dispatch(getPaymentMethods(client?.id))
        }
    }, [resultPaymentMethod, client?.id, dispatch, t])

    return (
        <>
            <Container className='cuerpo'>
                <Row className='mb-4'>
                    <Col className='d-flex align-items-center'>
                        <img src="/images/config.svg" alt="Icono Perfil"/>
                        <h1 className='ms-2 m-0'>{t('config.candidate.config')}</h1>
                    </Col>
                </Row>
                <Form onSubmit={handleAdd}>
                    <Row>
                        <Col>
                            <Card className='mb-5 sombra'>
                                <Card.Body className='px-5 pt-5'>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='email'>{t('users.email')}</Form.Label>
                                            <Form.Control
                                                type='email'
                                                name='email'
                                                value={formState.email ||  ''}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='password'>{t('passwordreset.new_password')}</Form.Label>
                                            <Form.Control
                                                type={showPassword ? 'text' : 'password'}
                                                name="password"
                                                autoComplete="off"
                                                onChange={e => checkValidation(e, 'first')}
                                            /><i className={`fas fa-eye${showPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowPassword(!showPassword)}></i>
                                        </Col>
                                        <Col xs='12' lg='6' className="my-2">
                                            <Form.Label htmlFor='confirm_password'>{t('passwordreset.confirm_password')}</Form.Label>
                                            <Form.Control
                                                type={showRepeatPassword ? 'text' : 'password'}
                                                name="confirm_password"
                                                autoComplete="off"
                                                onChange={e => checkValidation(e, 'second')}
                                            />
                                            <i className={`fas fa-eye${showRepeatPassword ? '-slash' : ''} sd-eye`} onClick={() => setShowRepeatPassword(!showRepeatPassword)}></i>
                                        </Col>
                                    </Row>
                                    {/* Mostramos si coinciden o no las contraseñas */}
                                    {isError !== ''
                                        ?
                                            <Row className="text-center my-3">
                                                <Col>
                                                    <div className="text-danger">* {t('passwordreset.passwordsdoesnotmatch')} *</div>
                                                </Col>
                                            </Row>
                                        :
                                            <></>
                                    }
                                    <Row>
                                        <Col className='d-flex justify-content-start align-items-start'>
                                            <Form.Check type='checkbox' name='switch' onChange={e => handleAvailability(e)} checked={formState.notifications || false} />
                                            <label className="label-checkbox ms-3" htmlFor="switch">{t('config.school.notifications')}</label>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className='d-flex justify-content-start align-items-start'>
                                            <Form.Check type='checkbox' name='marketing' onChange={handleCheckboxChange} checked={formState.marketing || false} />
                                            <label className="label-checkbox ms-3" htmlFor="marketing">{t('users.marketing')}</label>
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="submit" className="btn-primary w-100 my-2" disabled={hasNewPassword}>{t('config.school.updateuser')}</Button>
                                        </Col>
                                    </Row>
                                    <Row className="my-3 d-flex justify-content-end">
                                        <Col xs='12' lg='4'>
                                            <Button type="button" variant='danger' className="w-100 my-2" onClick={handleDeleteAccount}>{t('global.deleteAccount')}</Button>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Form>
                <Modal size='lg' show={showPaymentMethodModal} onHide={() => setShowPaymentMethodModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{t('config.school.addPaymentMethod')}</Modal.Title>
                    </Modal.Header>
                    <AddPaymentMethod/>
                </Modal>
            </Container>
        </>
    )
}